import React from 'react';
import {
	LineChart,
	Line,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
} from 'recharts';

import Title from './Title';
import { blue_pilu, money } from '../../../helpers/utils';

const CustomTooltip = ({ active, payload }) => {
	if (active) {
		return (
			<div
				className='custom-tooltip'
				style={{ backgroundColor: '#f2f2f2', padding: '10px' }}
			>
				<p className='label'>
					{payload?.length > 0 ? payload[0]?.payload?.name : '-'}
				</p>
				<p className='intro'>
					Importe:{' '}
					{payload?.length > 0
						? money(payload[0]?.payload?.importe)
						: '-'}
				</p>
			</div>
		);
	}

	return null;
};

const CustomYAxisTick = (props) => {
	const { x, y, payload } = props;

	// Format the Y-axis label as desired
	const finalValue = payload.value / 1000000;

	return (
		<g transform={`translate(${x},${y})`}>
			<text x={0} y={0} dy={16} textAnchor='end' fill='#666'>
				{finalValue ? `$${finalValue}M` : '.'}
			</text>
		</g>
	);
};

export default function Chart({
	data = null,
	month,
	title = 'Importe de ventas',
}) {
	return (
		<>
			{data && (
				<div style={{ width: '100%' }}>
					<Title>
						{title} ({month}):{' '}
						{money(
							data?.reduce((sum, item) => sum + item.importe, 0)
						)}
					</Title>
					<ResponsiveContainer width='100%' height={200}>
						<LineChart
							width={500}
							height={200}
							data={data}
							margin={{
								top: 10,
								right: 30,
								left: 0,
								bottom: 0,
							}}
						>
							<CartesianGrid strokeDasharray='3 3' />
							<XAxis dataKey='name' />
							<YAxis tick={<CustomYAxisTick />} />
							<Tooltip content={<CustomTooltip />} />
							<Line
								connectNulls
								type='monotone'
								dataKey='importe'
								stroke={blue_pilu}
								fill={blue_pilu}
							/>
						</LineChart>
					</ResponsiveContainer>
				</div>
			)}
		</>
	);
}
